<template>
    <div>
        <h1 class="mt-2 mb-4 font-sans-bold">Collaborator Agreement</h1>
        <div class="w-full my-3 overflow-y-scroll mb-12 contract-text" v-html="contractLegal"></div>
    </div>
</template>

<script>
    export default {
        name: 'ContractDisplay',
        title: 'Contract',
        props: {},
        components:{},
        data: () => ({
            contract: null,
            contractLegal: ''
        }),
        computed: {},
        watch: {},
        methods: {
            getContract() {
                var contract = this.$route.params.contract
                var id = contract.replace('contract-v-', '')

                let route = this.$laroute.route('api.contracts.show', { contract: id })
                axios.get(route).then((response) => {
                    this.contract = response.data.data
                    this.contractLegal = this.contract.legal
                })
                .catch((error) => {
                    console.log(error)
                    console.log(error.response)
                })
            }
        },
        mounted() {
            this.getContract()
        }
    }
</script>
